import * as B from '@blueprintjs/core';
import classNames from 'classnames';
import React from 'react';

import cs from './styles.module.scss';

export const RunProgressBar: React.FC<{
  savedCount: number;
  dismissedCount: number;
  newCount: number;
}> = ({savedCount, dismissedCount, newCount}) => {
  const totalCount = savedCount + dismissedCount + newCount;
  const savedPercentage = (savedCount / totalCount) * 100;
  const dismissedPercentage = (dismissedCount / totalCount) * 100;
  const newPercentage = (newCount / totalCount) * 100;

  const leftSavedPercentage = dismissedPercentage;
  const leftNewPercentage = dismissedPercentage + savedPercentage;

  return (
    <div className={cs.runProgressBarContainer}>
      <div role="progressbar" className={cs.runProgressBar}>
        <span
          style={{
            left: 0,
            width: `${dismissedPercentage}%`,
          }}
          className={classNames(cs.dismissed, cs.runProgressBarChunk)}
        />
        <span
          style={{
            left: `${leftSavedPercentage}%`,
            width: `${savedPercentage}%`,
          }}
          className={classNames(cs.saved, cs.runProgressBarChunk)}
        />
        <span
          style={{
            left: `${leftNewPercentage}%`,
            width: `${newPercentage}%`,
          }}
          className={classNames(cs.todo, cs.runProgressBarChunk)}
        />
      </div>
    </div>
  );
};

export const RunProgressBarStatus: React.FC<{
  savedCount: number;
  dismissedCount: number;
  newCount: number;
  showLabels?: boolean;
}> = ({savedCount, dismissedCount, newCount, showLabels = true}) => {
  return (
    <div className={cs.progressBarLegend}>
      <div className={cs.progressBarLegendItem}>
        <B.Tag intent="danger" icon="cross" minimal title="Dismissed">
          {showLabels ? `${dismissedCount} dismissed` : dismissedCount}
        </B.Tag>
      </div>
      <div className={cs.progressBarLegendItem}>
        <B.Tag intent="success" icon="tick" minimal title="Saved">
          {showLabels ? `${savedCount} saved` : savedCount}
        </B.Tag>
      </div>
      <div className={cs.progressBarLegendItem}>
        <B.Tag className={cs.todoTag} icon="form" minimal title="New">
          {showLabels ? `${newCount} remaining` : newCount}
        </B.Tag>
      </div>
    </div>
  );
};
